import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { NAV_LINKS, LOGO_MARK } from '../mock';
import { useCart } from '../context/CartContext';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { count, setOpen: setCartOpen } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const NAV_ITEMS = [{ name: 'Menu', path: '/menu' }, ...NAV_LINKS];

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-24">
        <Link to="/" className="flex items-center">
          <img src={LOGO_MARK} alt="Wrappus" className="h-14 md:h-16 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_ITEMS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) => `text-[15px] font-semibold tracking-wide transition-colors ${isActive ? 'text-[#ED2E2E]' : 'text-[#0F1C2E] hover:text-[#ED2E2E]'}`}
            >
              {link.name}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button onClick={() => setCartOpen(true)} className="relative w-11 h-11 rounded-full bg-[#FDF3EC] hover:bg-[#f5d9c8] text-[#0F1C2E] flex items-center justify-center transition-colors">
            <ShoppingCart size={18} />
            {count > 0 && <span className="absolute -top-1 -right-1 min-w-5 h-5 rounded-full bg-[#ED2E2E] text-white text-[10px] font-bold flex items-center justify-center px-1.5">{count}</span>}
          </button>
          <Link to="/menu" className="hidden sm:inline-flex btn-wrappus text-sm py-2.5 px-5">
            <ShoppingCart size={16} strokeWidth={2.5} />
            <span>Order Online</span>
          </Link>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#0F1C2E]">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 flex flex-col gap-4">
            <Link to="/" className="font-semibold text-[#0F1C2E]">Home</Link>
            {NAV_ITEMS.map((l) => (
              <Link key={l.path} to={l.path} className="font-semibold text-[#0F1C2E]">{l.name}</Link>
            ))}
            <Link to="/menu" className="btn-wrappus w-fit text-sm">
              <ShoppingCart size={16} /> Order Online
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
